import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { APP_URL } from "../request/api";
import { request } from "../request/request";

import { fetchVehiclesUpload } from "./vehiclesUploadSlice";

const initialState = {
    columns: [],
    data: {},
    warning: [],
    activities: [],
    images: [],
    loadingStatus: "idle",
    error: null
}

export const fetchVehiclesDetails = createAsyncThunk(
    'vehiclesDetails/fetchVehiclesDetails',
    async ({token, id}, {rejectWithValue}) => {
        try {
            const customHeaders = {
                Authorization: `Bearer ${token}`
            };

            const response = await request(
                `${APP_URL}/vehicles/${id}`,
                'GET',
                null,
                customHeaders
            );

            return response;
        } catch (error) {
            rejectWithValue(error.status);
        }
    }
);

const vehiclesDetailsSlice = createSlice({
    name: 'vehiclesDetails',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchVehiclesDetails.pending, (state) => {
                state.loadingStatus = "loading";
                state.error = null;
            })
            .addCase(fetchVehiclesDetails.fulfilled, (state, action) => {
                state.loadingStatus = "idle";
                state.columns = action.payload?.columns || [];
                state.data = action.payload?.data || {};
                state.activities = action.payload?.activities || [];
                state.warning = action.payload?.alerts?.warning || [];
                state.images = action.payload?.images || [];
                state.error = null;
            })
            .addCase(fetchVehiclesDetails.rejected, (state, action) => {
                state.loadingStatus = "error";
                state.error = action.payload;
            })
    }
});

export default vehiclesDetailsSlice.reducer;